<template><!-- svgo-optimised -->
<svg class="icon icon__pause" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M9 17V7h2v10H9Zm5 0V7h2v10h-2Z"/></svg></template>